import { render, staticRenderFns } from "./EditorV5.vue?vue&type=template&id=2c5a286e"
import script from "./EditorV5.vue?vue&type=script&lang=js"
export * from "./EditorV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports